import React, { useState, useEffect } from "react";
import logoBanner from '../../Assests/4f71dc90cc29b4ed69de0636891985f083fdf283.png'
import arrow from '../../Assests/left-arrow.png'
import './Category.css'
import ProductInfo from "../ProductInfo/ProductInfo";
import { urlApiServerImage } from "../../Config/Config";


function Category(props) {

    console.log('props: ', props)

    const [filteredProducts, setFilteredProducts] = useState([]);
    const [selectProduct, setSelectProduct] = useState(false);
    const [infoProduct, setInfoProduct] = useState();

    useEffect(() => {
        // Scroll to top when component mounts
        window.scrollTo(0, 0);
    }, [props]);

    useEffect(() => {
        if (props.product && props.Category) {
            // Filtrar solo por categoría, sin filtro de año
            const matchingProducts = props.product.filter(product =>
                product.categorias?.some(cat => cat.Nombre === props.Category.Nombre)
            );
            setFilteredProducts(matchingProducts);
        }
    }, [props.product, props.Category]);

    console.log('Productos filtrados:', filteredProducts);

    async function handleProduct(e) {
        setSelectProduct(true);

        setInfoProduct(e);

    }

    function handleCloseArticle() {
        // Aquí necesitamos acceder a la función que cambia el estado en el componente padre
        // Como estamos pasando la prop 'onClose' desde Articles, la usamos así:
        if (props.onClose) {
            props.onClose();
        }
    }

    return (
        <>
            {(selectProduct === false) ? (
                <>
                    <div className="bannerContainer" style={{ backgroundImage: `url(${props.background})`, height: '42vh' }}>
                        <img src={logoBanner} alt="logoBanner" className="logoBanner" />
                    </div>
                    <img src={arrow} alt="arrow" className="arrowBack" onClick={handleCloseArticle} />
                    <p className="titleCategoryName">{props.Category.Nombre}</p>
                    <div className="categoryProductsContainer">
                        <div className="productGrid">
                            {filteredProducts.map(item => (
                                <div key={item.id} className="productCard" onClick={() => handleProduct(item)}>
                                    <img
                                        src={urlApiServerImage + item.Imagenes[0]?.url}
                                        alt={item.Nombre}
                                        className="productImage"
                                    />
                                    <p className="productTitle">{item.Nombre}</p>
                                    <p className="productID">ID {item.id}</p>
                                    {item.Mostrar_Precio && <p className="productPrice">Desde $ {item.precio} USD</p>}
                                </div>
                            ))}
                        </div>
                    </div>
                </>
            ) : (
                <ProductInfo product={infoProduct} background={props.background} onClose={() => setSelectProduct(false)} />
            )}
        </>
    )
}

export default Category;